import script from "./OrderForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderForm.vue?vue&type=script&setup=true&lang=js"

import "./OrderForm.vue?vue&type=style&index=0&id=21252dad&lang=scss"

const __exports__ = script;

export default __exports__